"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dotx = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DotxSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M20.5 20.25a.75.75 0 0 1-.75.75H8v.75a.25.25 0 0 0 .25.25h13a.25.25 0 0 0 .25-.25v-18h.25V3.5l-1.5-1v1.75h.25z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M6.75 20.5h13a.25.25 0 0 0 .25-.25v-16H6.5v16a.25.25 0 0 0 .25.25"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    d: "M21.5 3.75v18a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V21h11.75a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25v-16H6v16c0 .413.337.75.75.75h.75v.75c0 .413.337.75.75.75h13a.75.75 0 0 0 .75-.75v-18z",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#41A5EE",
    d: "M20.5 1.549a.5.5 0 0 0-.207-.049H6.5A.5.5 0 0 0 6 2v2l.25.25h14L20.5 4v-.625l.25-.25V2.25z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#2B7CD3",
    fillRule: "evenodd",
    d: "m22 4.5-1.073-1.073a.25.25 0 0 0-.427.176V1.548a.5.5 0 0 1 .146.098l1.207 1.207a.5.5 0 0 1 .147.354zM20.5 4H6v.5h14.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#103F91",
    d: "M18.25 15H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#185ABD",
    d: "M18.25 13.5H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#2B7CD3",
    d: "M18.25 12H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#41A5EE",
    d: "M18.25 10.5H14v.5h4.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#185ABD",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F9F7F7",
    d: "M5.915 14.661q.024.196.032.342h.019q.033-.335.107-.664L6.96 10.5h1.148l.918 3.782q.069.28.115.713h.015q.02-.3.095-.69l.736-3.805h1.043L9.747 16H8.525l-.876-3.643a8 8 0 0 1-.146-.78H7.49q-.015.135-.06.4-.045.264-.07.391L6.536 16h-1.24L4 10.5h1.064l.798 3.847q.026.12.053.314"
  })]
});
const Dotx = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: DotxSvg
}));
exports.Dotx = Dotx;